import useCustomMutation from "@/hooks/useCustomMutation";
import { queryClient } from "@config/queryClient.config";
import { notifyError, notifySuccess } from "@shared/Toast/toast";

export default function useDeleteHomeWork({ id, onSettled, lang }) {
  const { mutate: deleteHomeWorkMutation, isPending } = useCustomMutation({
    url: `homeWork/deleteHomeWork?homework_id=${id}`,
    invalidate: ["module homework", id],
    method: "delete",
    onSettled,
    lang,
    onSuccess: () => {
      notifySuccess(
        lang == "ar"
          ? "تم حذف الواجب بنجاح"
          : "The Homework has been successfully deleted"
      );
      queryClient.invalidateQueries(["module homework"]);
    },
    onError: (err) => {
      console.log(err);
      notifyError(err?.response?.data?.message);
    },
  });

  function deleteHomeWork() {
    deleteHomeWorkMutation();
  }

  return { deleteHomeWork, isPending };
}
